"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fontFamilyNotoSansRtl = exports.fontFamilyNotoSansLtr = exports.fontFamilyOutfitLtr = exports.fontFamilyRobotoLtr = void 0;
exports.fontFamilyRobotoLtr = 'Roboto';
exports.fontFamilyOutfitLtr = 'Outfit';
exports.fontFamilyNotoSansLtr = 'Noto Sans';
exports.fontFamilyNotoSansRtl = 'NotoSans';